import { render, staticRenderFns } from "./PossibleClones.vue?vue&type=template&id=81f351f6&scoped=true&"
import script from "./PossibleClones.vue?vue&type=script&lang=js&"
export * from "./PossibleClones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f351f6",
  null
  
)

export default component.exports